import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { songPickerMessages as m } from './songPickerMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the picker; each part uses its own slice of it */
import styles from './SongPicker.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongPickerAddCardProps {
  onClick: () => void;
}

/** The dashed card at the end of "Coming out" (design t1): it opens the add-unreleased modal. */
const SongPickerAddCardComponent: React.FC<SongPickerAddCardProps> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <button type="button" className={styles.addCard} data-testid="song-picker-add" onClick={onClick}>
      <span className={styles.plus} aria-hidden="true">
        +
      </span>
      <span className="d-flex flex-column">
        <b>{intl.formatMessage(m.addTitle)}</b>
        <span>{intl.formatMessage(m.addBody)}</span>
      </span>
    </button>
  );
};

export const SongPickerAddCard = TypedMemo(SongPickerAddCardComponent);
